import { Incentive } from "@/pages/incentive";
import { IncentiveManagerPage } from "@/pages/incentive/manager";
import { MILL_2 } from "../mill-config/mill-config";

export const routeIncentive = "/incentive";
export const routeIncentiveManager = "/incentive/manager";
export const incentiveDashboardPermission =
	"ui.navbar.mill.incentive.dashboard";
export const incentiveManagerPermission = "ui.navbar.mill.incentive.manager";

export const incentiveRoutes = [
	{
		path: routeIncentive,
		element: <Incentive assetId={MILL_2.id} />,
		permission: incentiveDashboardPermission,
	},
	{
		path: routeIncentiveManager,
		element: <IncentiveManagerPage assetId={MILL_2.id} />,
		permission: incentiveManagerPermission,
	},
];
